export default __webpack_public_path__ + "static/media/Poke_Freeze.f2b1414e.png";